module.exports = __webpack_public_path__ + "img/program.d60a8c6f.png";